/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useState, useRef } from "react";
import Input from "../../../component/inputpm";
import { withTranslation } from "react-i18next";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
} from "@mui/material";
import Button from "../../../component/button";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
// import { makeStyles } from '@mui/styles';

const PreQualificationVerification = (props) => {
  const t = props.t;
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();
  const setInputType = (val) => {
    if (val === "string") {
      return "text";
    } else if (val === "number" || val === "decimal") {
      return "number";
    } else if (val === "email") {
      return "email";
    } else if (val === "date") {
      return "date";
    } else if (val === "datetime") {
      return "datetime-local";
    } else {
      return "text";
    }
  };

  return (
    <>
      <Dialog
        disableScrollLock={true}
        maxWidth={"md"}
        PaperComponent={DraggableDialogPaper}
        fullWidth={true}
        open={props.openVerifyDialog}
        aria-labelledby="import-dialog-title"
        // PaperProps={{
        //     className: classess.resizablePaper
        // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          {t("QUALIFICATIONS_VERIFICATION_TITLE")}
        </DialogTitle>
        <DialogContent dividers>
          {props.preQualsData &&
            props.preQualsData.length > 0 &&
            props.preQualsData.map((item, i) => (
              <TableContainer>
                <Table
                  key={i}
                  className={"prequalification-verification-table"}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={10}>{item.resourceName}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* <TableRow>
                                    {(item.parameters).map((param, j) =>
                                        <TableCell key={j}>{param.label}</TableCell>
                                    )}
                                </TableRow> */}
                    <TableRow>
                      {item.parameters.map((input, k) =>
                        input.type === "boolean" ? (
                          <TableCell
                            align="left"
                            key={k}
                            style={{ borderBottom: 0, verticalAlign: "top" }}
                          >
                            {/* <Checkbox
                                                checked={input.value}
                                                onChange={(e) => props.onChangePreQualData(e, i, k)}
                                                color="primary"
                                                name={input.name}
                                            />
                                            {input.label} */}
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={input.value}
                                  onChange={(e) =>
                                    props.onChangePreQualData(e, i, k)
                                  }
                                  name={input.name}
                                />
                              }
                              label={input.label}
                              style={{
                                marginRight: 0,
                                marginLeft: 0,
                                paddingTop: 5,
                              }}
                            />
                          </TableCell>
                        ) : (
                          <TableCell
                            align="left"
                            key={k}
                            style={{ borderBottom: 0 }}
                          >
                            <Input
                              name={input.name}
                              value={input.value}
                              type={setInputType(input.type)}
                              // onBlur={(e) => props.validateInput(e, item.resourceId, k)}
                              onChange={(e) =>
                                props.onChangePreQualData(e, i, k)
                              }
                              placeholder={input.label}
                              autoComplete="on"
                              size={"small"}
                              variant={"outlined"}
                              inputProps={{
                                error: input.isInvalid,
                                helperText:
                                  input.isInvalid && t("INVALID_VALUE_ENTERED"),
                              }}
                            />
                            {input.validation ? (
                              <>
                                <br />
                                <span style={{ fontSize: "0.75rem" }}>
                                  {/* {t('REGEX_VALIDATION')}:  */}
                                  <b>{input.validation}</b>
                                </span>
                              </>
                            ) : (
                              <span>&nbsp;</span>
                            )}
                          </TableCell>
                        ),
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            ))}
        </DialogContent>
        <DialogActions>
          <div style={{ width: "50%", float: "left", fontWeight: "bold" }}>
            {props.preQualMessage}
          </div>
          <div style={{ width: "50%", float: "right", textAlign: "right" }}>
            <Button
              onClick={(event) => props.closeVerifyDialog(false)}
              color="primary"
              style={{ marginRight: "15px" }}
            >
              {t("CLOSE")}
            </Button>
            {props.disableButton ? (
              <Button
                onClick={(event) => props.closeVerifyDialog(false)}
                color="primary"
              >
                {t("PROCEED")}
              </Button>
            ) : (
              <Button
                onClick={(event) => props.closeVerifyDialog(true)}
                color="primary"
                disabled={props.disableButton}
              >
                {t("EXECUTE")}
              </Button>
            )}
          </div>
          <div style={{ clear: "both" }}></div>
        </DialogActions>
      </Dialog>
    </>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

export default withTranslation("translations")(PreQualificationVerification);
